<template lang="html">
    <div class="centerx" style="min-width: 800px;">
		<vs-popup :title="'Contrat N°' + contractId + ' ' + societyName"  :active.sync="isPopupActive">
			<div class="container-fluid">
				<div class="container-fluid">
					<h4>Achats</h4>
					<vs-table :data="list" pagination :max-items="15" stripe auto-resize>
						<template slot="thead">
							<vs-th class="text-center" sort-key="user_name"><vs-spacer /><span>Ajouté par</span><vs-spacer /></vs-th>
							<vs-th class="text-center" sort-key="service_name"><vs-spacer /><span>Service</span><vs-spacer /></vs-th>
							<vs-th class="text-center" sort-key="provider_name"><vs-spacer /><span>Prestataire</span><vs-spacer /></vs-th>
							<vs-th class="text-center" sort-key="price"><vs-spacer /><span>Prix Achat (HT)</span></vs-th>
							<vs-th class="text-center" sort-key="sell_price"><vs-spacer /><span>Prix de Vente (HT)</span></vs-th>
							<vs-th class="text-center" sort-key="input_date"><vs-spacer /><span>Date de saisie</span><vs-spacer /></vs-th>
							<vs-th class="text-center" sort-key="recurrence"><vs-spacer /><span>Récurrence</span><vs-spacer /></vs-th>
							<!-- <vs-th class="text-center">Est un achat récurrent ?</vs-th> -->
							<vs-th class="text-center" sort-key="is_billable"><vs-spacer /><span>Facturable</span><vs-spacer /></vs-th>
							<vs-th class="text-center" sort-key="commentary"><vs-spacer /><span>Commentaire</span><vs-spacer /></vs-th>
						</template>
						<template slot-scope="{data}">
							<vs-tr :key="index" v-for="(purchase, index) in data">
								<vs-td :data="purchase.user_id" class="text-center">
									<span class="hvr-underline hvr-underline-out">
										<vx-tooltip
											:text="`${purchase.user_firstname} ${purchase.user_lastname}`"
											position="top"
											style="text-align: center;"
										>
											<vs-avatar
												style="border: 1px solid gray;"
												:text="`${purchase.user_firstname} ${purchase.user_lastname}`"
												:src="getCollaboratorAvatar(purchase.user_id)"
											/>
										</vx-tooltip>
									</span>
								</vs-td>
								<vs-td :data="purchase.service_name" class="text-center">{{ getServiceIdToName(purchase.service_id) }}</vs-td>
								<vs-td :data="purchase.provider_name" class="text-center"> {{ getProviderIdToName(purchase.users_id) }}</vs-td>
								<vs-td :data="purchase.price" class="text-right"> {{ purchase.recurrence_date ? convertInternationalNumberToFrenchCurrency(purchase.recurrence_price) : convertInternationalNumberToFrenchCurrency(purchase.price) }}</vs-td>
								<vs-td :data="purchase.sell_price" class="text-right" v-if="purchase.is_billable"> {{ purchase.recurrence_date ? convertInternationalNumberToFrenchCurrency(purchase.recurrence_price) : convertInternationalNumberToFrenchCurrency(purchase.sell_price) }}</vs-td>
								<vs-td :data="purchase.sell_price" class="text-right" v-else></vs-td>
								<vs-td :data="purchase.input_date" class="text-center"> {{ purchase.recurrence_date ? getDateToFrenchFormat(formatDate(purchase.recurrence_date)) : getDateToFrenchFormat(formatDate(purchase.input_date)) }}</vs-td>
								<vs-td :data="purchase.recurrence" class="text-center"> {{ getPurchaseFrequency(purchase.recurrence) }}</vs-td>
								<!-- <vs-td :data="purchase.recurrence_date" class="text-center"> {{ purchase.recurrence_date ? "Oui" : "Non" }}</vs-td> -->
								<vs-td :data="purchase.is_billable" class="text-center"> {{ getUserDashboardAccess(purchase.is_billable) }}</vs-td>
								<vs-td :data="purchase.commentary" class="text-center"> {{ purchase.commentary }}</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</div>

				<div class="container-fluid" v-if="netlinksList.length > 0">
					<h4>Netlinks</h4>
					<vs-table :data="netlinksList" class="mt-4" stripe :key="refreshKey">
						<template slot="thead">
							<vs-th sort-key="url_bought">Lien acheté</vs-th>
							<vs-th sort-key="landing_page">Landing page</vs-th>
							<vs-th sort-key="anchor_type">Type Ancre</vs-th>
							<vs-th sort-key="link_type">Type Lien</vs-th>
							<vs-th sort-key="creation_date" style="text-align: center;">Date Achat/Création</vs-th>
							<vs-th sort-key="status" style="display: flex; justify-content: center; margin-left: -5px;">Statut</vs-th>
						</template>
						<template slot-scope="{data}">
							<vs-tr :key="index" v-for="(oneNetlink, index) in data">
								<vs-td :data="oneNetlink.url_bought"><a class="hvr-underline hvr-underline-out" :href="oneNetlink.url_bought" target="_blank">{{ oneNetlink.url_bought }}</a></vs-td>
								<vs-td :data="oneNetlink.landing_page">
									<a class="hvr-underline hvr-underline-out" :href="oneNetlink.landing_page" target="_blank">{{ oneNetlink.landing_page }}</a>
								</vs-td>

								<vs-td :data="oneNetlink.anchor_type">{{ getNetlinkAnchorType(oneNetlink.anchor_type) }}</vs-td>
								<vs-td :data="oneNetlink.link_type">{{ getNetlinkTypeName(oneNetlink.link_type) }}</vs-td>
								<vs-td :data="oneNetlink.creation_date"> {{ oneNetlink.creation_date ? getDateToFrenchFormat(oneNetlink.creation_date.substring(0,10)) : getDateToFrenchFormat(getPurchaseIdToPurchaseDate(oneNetlink.purchase_id)) }}</vs-td>

								<vs-td :data="oneNetlink.status" style="text-align: center;">
									<vs-chip
									style="width: 80px"
									:color="getNetlinkStatusColor(oneNetlink.status)"
									class="ml-2"
									>{{
									getNetlinkStatus(oneNetlink.status)
									}}</vs-chip>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
					<div class="vx-col w-full mb-2">
						<vs-button style="float: right; margin-top: 20px;"
							icon-pack="feather" icon="icon-download-cloud"
							color="dark"
							@click="exportData(netlinksList)"
						>Exporter Netlinks
						</vs-button>
					</div>
				</div>
      		</div>
    	</vs-popup>
  	</div>
</template>

<script>
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import "@/assets/css/toggle-switch.css";
import XLSX from "xlsx";


export default {
	name: "BudgetDetailPopup",
	props: {
		popupActive: Boolean,
		router: Object,
		apiUrl: String,
		year: String,
		month: String,
		contractId: Number,
		missionId: Number,
		societyName: String,
		allCollaboratorsAvatar: Array,
		netlink_types: Array,
		services: Array,
		societies: Array,
		providers: Array,
		isTabNetlink: Boolean
	},
	mixins: [dbFieldConvertor, utilsMixin],
	components: {
	},
	beforeCreate(){
	},
	created(){
		this.getAllPurchasesForContract();
		this.getAllNetlinksForContract();
	},
	computed: {
	},
	watch: {
	},

	data() {
		return {
			list: [],
			netlinksList: [],
			isPopupActive: this.$props.popupActive,
			/*
			 * linkNameFilter: null,
			 * typeFilter: null,
			 * statusFilter: null,
			 */
			netlinkStatus: [
				{text: "Actif", value: 0},
				{text: "En\u00a0attente", value: 1},
				{text: "Refusé", value: 2},
				{text: "Terminé", value: 3},
				{text: "En\u00a0cours\u00a0de\u00a0rédaction", value: 4},
				{text: "Annulé", value: 5}
			],
			refreshKey: 0
		};
	},

	methods: {
		exportData(dataIn){
			let data = JSON.parse(JSON.stringify(dataIn));

			for(let i = 0; i < data.length; i++){
				data[i]["status"] = this.getNetlinkStatus(data[i]["status"]);
				data[i]["link_type"] = this.getNetlinkTypeName(data[i]["link_type"]);
				data[i]["anchor_type"] = this.getNetlinkAnchorType(data[i]["anchor_type"]);
				data[i]["society_id"] = this.research(data[i]["society_id"], this.societies, "id", "name");
				data[i]["creation_date"] = this.dateToFR(data[i]["creation_date"]);

				for(let x in data[i]){
					data[i][x] = String(data[i][x]).trim();
				}

				this.$delete(data[i], "dns_id");
				this.$delete(data[i], "provider_id");
				this.$delete(data[i], "renew_date");
				this.$delete(data[i], "renew_duration");

				this.$delete(data[i], "id");
				this.$delete(data[i], "contract_id");
				this.$delete(data[i], "provider_name");
				this.$delete(data[i], "price");
				this.$delete(data[i], "domain_authority");
				this.$delete(data[i], "page_authority");
				this.$delete(data[i], "ref_domains");
				this.$delete(data[i], "external_links");
				this.$delete(data[i], "trust_flow");
				this.$delete(data[i], "citation_flow");
				this.$delete(data[i], "purchase_id");
				this.$delete(data[i], "recurring_purchase_id");
			}

			// let today =
			let wb = XLSX.utils.book_new();
			let ws_name = "Netlink";

			let header = {
				header: [
					"society_id",
					"link_type",
					"anchor_type",
					"url_bought",
					"landing_page",
					"creation_date",
					"status",
				],
				skipHeader: true,
				origin: -1
			};

			let header_names = [{
				society_id: "Société",
				link_type: "Type lien",
				anchor_type: "Type ancre",
				url_bought: "Lien",
				landing_page: "Landing Page",
				creation_date: "Date de création",
				status: "Statut",
			}];


			let ws = XLSX.utils.json_to_sheet(header_names, header);
			XLSX.utils.sheet_add_json(ws, data, header);

			/* Add the worksheet to the workbook */
			XLSX.utils.book_append_sheet(wb, ws, ws_name);
			let filename = "Netlinks_export";
			if(data.length > 0){
				// //console.log("Budget data", data);
				// let society_name = this.research(data[0]["society_id"], this.societies, "id", "name");
				// //console.log("Budget society_name", society_name);
				// if(society_name.length > 0){
				filename = data[0]["society_id"];
				// }
			}
			XLSX.writeFile(wb, `${filename}_netlinks.xls`);
		},
		formatDate(date_input){
			if(date_input && date_input.length > 10){
				return date_input.substring(0, 10);
			}
			else{
				return date_input;
			}
		},

		getCollaboratorAvatar(userId){
			let foundAvatar = this.allCollaboratorsAvatar.find(avatar => avatar.id == userId);
			if(foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		async getAllPurchasesForContract(){
			await this.$http.get(this.apiUrl + `account_manager_view/contract/${this.contractId}/${this.year}/${this.month}`)
				.then(res => {
					if(this.isTabNetlink) this.list = res.data.filter(purchase => purchase.service_id == 10);
					else this.list = res.data
				})
				.catch(err => {
					//console.log(err);
				}
			);
		},

		async getAllNetlinksForContract(){
			await this.$http.get(this.apiUrl + `account_manager_view/contract/netlink/${this.contractId}/${this.year}/${this.month}`)
				.then(res => {
					this.netlinksList = res.data;
				})
				.catch(err => {
					//console.log(err);
				}
				);
		},

		getNetlinkTypeName(netlinkTypeId){
			let foundNetlinkType = this.netlink_types.findIndex(row => row.id == netlinkTypeId);
			if(foundNetlinkType >= 0) return this.netlink_types[foundNetlinkType].name;
			else" ";
		},
		getProviderIdToName(provider_id){
			let provider_name = "";
			let provider = this.providers.find(provider => provider.id == provider_id);
			if(provider != undefined && provider.society != undefined){
				provider_name = provider.society;
			}
			return provider_name;
		},
		getServiceIdToName(service_id){
			let service_name = "";
			let service = this.services.find(service => service.id == service_id);
			if(service != undefined && service.name != undefined){
				service_name = service.name;
			}
			return service_name;
		},
		updateNetlink(netlink){
			this.$emit("modify-netlink", netlink);
		},
	}
};
</script>

<style scoped>
.table-client{
  padding: 0 20px 20px 20px;
}
.thead-client{
  white-space: nowrap;
}
.center {
  justify-content: center;
}

.hvr-underline-out{
  color: black;
}
.hvr-underline:hover{
  color:aqua;
  text-decoration: underline;
  cursor: pointer;
}
</style>
